import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const FLAGS_SECTION_V2_FLAG_KEY = 'release-scribe-dev-tools-flag-panel';
export const FLAGS_SECTION_V2_FLAG_DEFAULT = false;

export const useIsFlagsSectionV2Enabled = () =>
  useBooleanFlagValue(FLAGS_SECTION_V2_FLAG_KEY, FLAGS_SECTION_V2_FLAG_DEFAULT);
